export const featuredProperties = [
  {
    id: 1,
    title: "Oakwood Assisted Living",
    type: "Assisted Living",
    price: "£1.2M Asset Value",
    location: "Manchester, England",
    beds: 14,
    baths: 14,
    sqft: 6800,
    tag: "FRI Lease",
    image: "https://readdy.ai/api/search-image?query=modern%20assisted%20living%20facility%20exterior%20UK%2C%20clean%20red%20brick%20architecture%2C%20accessible%20ramp%20entrance%2C%20well%20maintained%20garden%2C%20residential%20care%20home%2C%20warm%20afternoon%20light%2C%20professional%20real%20estate%20photography%2C%20urban%20suburban%20UK%20setting&width=600&height=400&seq=101&orientation=landscape",
  },
  {
    id: 2,
    title: "Birchfield Supported Housing",
    type: "Supported Housing",
    price: "£980K Asset Value",
    location: "Birmingham, England",
    beds: 10,
    baths: 10,
    sqft: 5200,
    tag: "25-Year Lease",
    image: "https://readdy.ai/api/search-image?query=UK%20supported%20housing%20building%20exterior%2C%20modern%20residential%20care%20facility%2C%20wheelchair%20accessible%2C%20clean%20facade%2C%20community%20garden%2C%20warm%20natural%20light%2C%20professional%20architecture%20photography%2C%20British%20residential%20street&width=600&height=400&seq=102&orientation=landscape",
  },
  {
    id: 3,
    title: "Riverside Care Residence",
    type: "Assisted Living",
    price: "£1.45M Asset Value",
    location: "Leeds, England",
    beds: 18,
    baths: 18,
    sqft: 8400,
    tag: "Fully Leased",
    image: "https://readdy.ai/api/search-image?query=riverside%20assisted%20living%20residence%20UK%2C%20modern%20care%20home%20building%2C%20large%20windows%2C%20accessible%20entrance%2C%20landscaped%20grounds%2C%20warm%20golden%20light%2C%20high%20quality%20real%20estate%20photo%2C%20Yorkshire%20England%20setting&width=600&height=400&seq=103&orientation=landscape",
  },
  {
    id: 4,
    title: "Greenhill Sheltered Housing",
    type: "Sheltered Housing",
    price: "£870K Asset Value",
    location: "Bristol, England",
    beds: 8,
    baths: 8,
    sqft: 4100,
    tag: "CPI+1% Rent",
    image: "https://readdy.ai/api/search-image?query=sheltered%20housing%20complex%20UK%2C%20modern%20affordable%20residential%20building%2C%20well%20maintained%20entrance%2C%20green%20garden%20spaces%2C%20accessible%20pathways%2C%20warm%20afternoon%20sun%2C%20professional%20photography%2C%20Bristol%20England%20residential&width=600&height=400&seq=104&orientation=landscape",
  },
];

export const allProperties = [
  ...featuredProperties,
  {
    id: 5,
    title: "Meadowview Assisted Living",
    type: "Assisted Living",
    price: "£1.65M Asset Value",
    location: "Sheffield, England",
    beds: 20,
    baths: 20,
    sqft: 9200,
    tag: "Fully Leased",
    image: "https://readdy.ai/api/search-image?query=large%20assisted%20living%20facility%20UK%2C%20premium%20care%20home%20building%2C%20spacious%20grounds%2C%20professional%20landscaping%2C%20modern%20architecture%2C%20warm%20light%2C%20high%20quality%20exterior%20photography%2C%20Sheffield%20England&width=600&height=400&seq=105&orientation=landscape",
  },
  {
    id: 6,
    title: "Lakeside Supported Homes",
    type: "Supported Housing",
    price: "£1.1M Asset Value",
    location: "Liverpool, England",
    beds: 12,
    baths: 12,
    sqft: 5800,
    tag: "FRI Lease",
    image: "https://readdy.ai/api/search-image?query=supported%20housing%20building%20UK%20near%20water%2C%20modern%20residential%20care%2C%20accessible%20design%2C%20lakeside%20setting%2C%20warm%20natural%20light%2C%20clean%20exterior%2C%20professional%20real%20estate%20photo%2C%20Merseyside%20England&width=600&height=400&seq=106&orientation=landscape",
  },
  {
    id: 7,
    title: "Fernwood Care Complex",
    type: "Assisted Living",
    price: "£2.1M Asset Value",
    location: "Nottingham, England",
    beds: 24,
    baths: 24,
    sqft: 11500,
    tag: "25-Year Lease",
    image: "https://readdy.ai/api/search-image?query=large%20care%20complex%20UK%2C%20premium%20assisted%20living%20facility%2C%20modern%20architecture%2C%20manicured%20grounds%2C%20accessible%20wide%20entrance%2C%20warm%20afternoon%20light%2C%20Nottinghamshire%20England%2C%20professional%20real%20estate%20photography&width=600&height=400&seq=107&orientation=landscape",
  },
  {
    id: 8,
    title: "Hillside Assisted Living",
    type: "Assisted Living",
    price: "£1.3M Asset Value",
    location: "Newcastle, England",
    beds: 16,
    baths: 16,
    sqft: 7600,
    tag: "Fully Leased",
    image: "https://readdy.ai/api/search-image?query=hillside%20care%20home%20UK%2C%20modern%20assisted%20living%20building%2C%20elevated%20position%2C%20panoramic%20views%2C%20accessible%20entrance%2C%20well%20kept%20garden%2C%20warm%20light%2C%20professional%20photography%2C%20Newcastle%20England%20residential&width=600&height=400&seq=108&orientation=landscape",
  },
  {
    id: 9,
    title: "Hartwell Supported Living",
    type: "Supported Housing",
    price: "£1.05M Asset Value",
    location: "Leicester, England",
    beds: 11,
    baths: 11,
    sqft: 5400,
    tag: "FRI Lease",
    image: "https://readdy.ai/api/search-image?query=supported%20living%20complex%20UK%20Midlands%2C%20modern%20brick%20residential%20care%20building%2C%20neat%20garden%20boundary%2C%20accessible%20paved%20entrance%2C%20warm%20summer%20daylight%2C%20professional%20property%20photograph%2C%20Leicester%20England&width=600&height=400&seq=109&orientation=landscape",
  },
  {
    id: 10,
    title: "Elmwood Court Sheltered Housing",
    type: "Sheltered Housing",
    price: "£760K Asset Value",
    location: "Coventry, England",
    beds: 9,
    baths: 9,
    sqft: 4600,
    tag: "CPI+1% Rent",
    image: "https://readdy.ai/api/search-image?query=sheltered%20housing%20courtyard%20UK%2C%20clean%20residential%20care%20building%2C%20wheelchair%20accessible%20paths%2C%20communal%20garden%20with%20benches%2C%20warm%20afternoon%20light%2C%20British%20architecture%2C%20professional%20exterior%20photography%2C%20Coventry%20Midlands%20England&width=600&height=400&seq=110&orientation=landscape",
  },
  {
    id: 11,
    title: "Parkside Assisted Living Centre",
    type: "Assisted Living",
    price: "£1.78M Asset Value",
    location: "Cardiff, Wales",
    beds: 22,
    baths: 22,
    sqft: 10100,
    tag: "25-Year Lease",
    image: "https://readdy.ai/api/search-image?query=modern%20assisted%20living%20centre%20Wales%2C%20large%20purpose-built%20care%20facility%2C%20well-maintained%20extensive%20grounds%2C%20wide%20accessible%20entrance%2C%20warm%20golden%20hour%20light%2C%20prestigious%20residential%20care%20architecture%2C%20Cardiff%20Wales%2C%20real%20estate%20photography&width=600&height=400&seq=111&orientation=landscape",
  },
  {
    id: 12,
    title: "Dunmore Supported Homes",
    type: "Supported Housing",
    price: "£890K Asset Value",
    location: "Edinburgh, Scotland",
    beds: 10,
    baths: 10,
    sqft: 4900,
    tag: "Fully Leased",
    image: "https://readdy.ai/api/search-image?query=supported%20housing%20Scotland%2C%20clean%20stone-faced%20residential%20care%20building%2C%20accessible%20ramp%2C%20neat%20front%20garden%2C%20overcast%20Scottish%20daylight%2C%20professional%20real%20estate%20photography%2C%20Edinburgh%20suburban%20street&width=600&height=400&seq=112&orientation=landscape",
  },
  {
    id: 13,
    title: "Stonehaven Assisted Living",
    type: "Assisted Living",
    price: "£1.42M Asset Value",
    location: "Southampton, England",
    beds: 17,
    baths: 17,
    sqft: 8100,
    tag: "FRI Lease",
    image: "https://readdy.ai/api/search-image?query=assisted%20living%20residence%20southern%20England%2C%20modern%20two-storey%20care%20home%2C%20wide%20parking%20area%2C%20landscaped%20entrance%20garden%2C%20warm%20coastal%20light%2C%20professional%20architectural%20photography%2C%20Hampshire%20England&width=600&height=400&seq=113&orientation=landscape",
  },
  {
    id: 14,
    title: "Redwood Manor Sheltered Housing",
    type: "Sheltered Housing",
    price: "£820K Asset Value",
    location: "Derby, England",
    beds: 8,
    baths: 8,
    sqft: 3900,
    tag: "CPI+1% Rent",
    image: "https://readdy.ai/api/search-image?query=sheltered%20housing%20manor%20UK%2C%20traditional%20residential%20care%20building%2C%20red%20brick%20facade%2C%20mature%20tree%20in%20front%20garden%2C%20accessible%20ground%20floor%20entry%2C%20warm%20afternoon%20light%2C%20professional%20real%20estate%20photography%2C%20Derbyshire%20England&width=600&height=400&seq=114&orientation=landscape",
  },
  {
    id: 15,
    title: "Clarendon Rise Supported Living",
    type: "Supported Housing",
    price: "£1.22M Asset Value",
    location: "Oxford, England",
    beds: 13,
    baths: 13,
    sqft: 6200,
    tag: "25-Year Lease",
    image: "https://readdy.ai/api/search-image?query=supported%20living%20building%20Oxfordshire%2C%20modern%20purpose-built%20residential%20care%2C%20clean%20rendered%20facade%2C%20accessible%20ramp%2C%20neat%20front%20boundary%2C%20warm%20summer%20light%2C%20Oxford%20England%2C%20professional%20exterior%20architecture%20photography&width=600&height=400&seq=115&orientation=landscape",
  },
  {
    id: 16,
    title: "Westgate Assisted Living",
    type: "Assisted Living",
    price: "£1.95M Asset Value",
    location: "Brighton, England",
    beds: 23,
    baths: 23,
    sqft: 10800,
    tag: "Fully Leased",
    image: "https://readdy.ai/api/search-image?query=premium%20assisted%20living%20facility%20Sussex%20coast%20England%2C%20large%20modern%20care%20home%2C%20bright%20seafront%20lighting%2C%20well%20maintained%20gardens%2C%20coastal%20residential%20architecture%2C%20warm%20summer%20daylight%2C%20professional%20real%20estate%20photography%2C%20Brighton%20East%20Sussex&width=600&height=400&seq=116&orientation=landscape",
  },
  {
    id: 17,
    title: "Heatherbrook Care Village",
    type: "Assisted Living",
    price: "£2.45M Asset Value",
    location: "York, England",
    beds: 28,
    baths: 28,
    sqft: 13200,
    tag: "FRI Lease",
    image: "https://readdy.ai/api/search-image?query=care%20village%20Yorkshire%20England%2C%20large%20campus-style%20assisted%20living%20complex%2C%20extensive%20landscaped%20gardens%2C%20modern%20warm%20brick%20buildings%2C%20wide%20accessible%20paths%2C%20golden%20afternoon%20light%2C%20professional%20drone%20photography%2C%20York%20England&width=600&height=400&seq=117&orientation=landscape",
  },
  {
    id: 18,
    title: "Aldersgate Supported Housing",
    type: "Supported Housing",
    price: "£930K Asset Value",
    location: "Norwich, England",
    beds: 11,
    baths: 11,
    sqft: 5100,
    tag: "25-Year Lease",
    image: "https://readdy.ai/api/search-image?query=supported%20housing%20Norfolk%20England%2C%20modern%20residential%20care%20building%2C%20well-kept%20garden%2C%20accessible%20entrance%2C%20neat%20brick%20facade%2C%20warm%20afternoon%20sunlight%2C%20professional%20property%20photography%2C%20Norwich%20England&width=600&height=400&seq=118&orientation=landscape",
  },
  {
    id: 19,
    title: "Millbank Sheltered Residence",
    type: "Sheltered Housing",
    price: "£780K Asset Value",
    location: "Stoke-on-Trent, England",
    beds: 9,
    baths: 9,
    sqft: 4300,
    tag: "CPI+1% Rent",
    image: "https://readdy.ai/api/search-image?query=sheltered%20housing%20residence%20Staffordshire%20England%2C%20two-storey%20residential%20care%20building%2C%20accessible%20flat%20entrance%2C%20community%20garden%2C%20calm%20residential%20street%2C%20warm%20natural%20light%2C%20professional%20architectural%20photography%2C%20Stoke-on-Trent&width=600&height=400&seq=119&orientation=landscape",
  },
  {
    id: 20,
    title: "Harrowgate Assisted Living",
    type: "Assisted Living",
    price: "£1.58M Asset Value",
    location: "Reading, England",
    beds: 19,
    baths: 19,
    sqft: 8900,
    tag: "Fully Leased",
    image: "https://readdy.ai/api/search-image?query=assisted%20living%20facility%20Berkshire%20England%2C%20purpose-built%20care%20home%2C%20contemporary%20architecture%2C%20neat%20landscaped%20grounds%2C%20accessible%20parking%2C%20warm%20daylight%2C%20professional%20real%20estate%20photography%2C%20Reading%20Berkshire%20England&width=600&height=400&seq=120&orientation=landscape",
  },
  {
    id: 21,
    title: "Thornfield Supported Living",
    type: "Supported Housing",
    price: "£1.14M Asset Value",
    location: "Wolverhampton, England",
    beds: 12,
    baths: 12,
    sqft: 5700,
    tag: "FRI Lease",
    image: "https://readdy.ai/api/search-image?query=supported%20living%20building%20West%20Midlands%20England%2C%20modern%20two-storey%20brick%20residential%20care%20facility%2C%20wide%20wheelchair%20accessible%20entrance%2C%20tidy%20front%20garden%2C%20warm%20afternoon%20sunlight%2C%20professional%20property%20photography%2C%20Wolverhampton%20England&width=600&height=400&seq=121&orientation=landscape",
  },
  {
    id: 22,
    title: "Kingsbridge Care Residence",
    type: "Assisted Living",
    price: "£1.86M Asset Value",
    location: "Exeter, England",
    beds: 21,
    baths: 21,
    sqft: 9800,
    tag: "25-Year Lease",
    image: "https://readdy.ai/api/search-image?query=premium%20care%20residence%20Devon%20England%2C%20elegant%20two%20storey%20assisted%20living%20building%2C%20sandstone%20facade%2C%20mature%20garden%20landscaping%2C%20wide%20accessible%20path%2C%20warm%20golden%20West%20Country%20light%2C%20professional%20architectural%20photography%2C%20Exeter%20Devon%20England&width=600&height=400&seq=122&orientation=landscape",
  },
  {
    id: 23,
    title: "Bluebell Court Sheltered Housing",
    type: "Sheltered Housing",
    price: "£845K Asset Value",
    location: "Sunderland, England",
    beds: 9,
    baths: 9,
    sqft: 4400,
    tag: "CPI+1% Rent",
    image: "https://readdy.ai/api/search-image?query=sheltered%20housing%20scheme%20North%20East%20England%2C%20neat%20one-storey%20residential%20care%20building%2C%20communal%20garden%20with%20flowers%2C%20accessible%20paved%20paths%2C%20clean%20brick%20exterior%2C%20Sunderland%20Tyne%20and%20Wear%20England%2C%20professional%20property%20photography&width=600&height=400&seq=123&orientation=landscape",
  },
  {
    id: 24,
    title: "Maple Grove Assisted Living",
    type: "Assisted Living",
    price: "£2.05M Asset Value",
    location: "Peterborough, England",
    beds: 24,
    baths: 24,
    sqft: 11200,
    tag: "Fully Leased",
    image: "https://readdy.ai/api/search-image?query=large%20assisted%20living%20complex%20Cambridgeshire%20England%2C%20modern%20purpose-built%20care%20facility%2C%20maple%20tree%20lined%20entrance%2C%20wide%20parking%20forecourt%2C%20well%20maintained%20gardens%2C%20warm%20autumn%20light%2C%20professional%20real%20estate%20photography%2C%20Peterborough%20England&width=600&height=400&seq=124&orientation=landscape",
  },
  {
    id: 25,
    title: "Highfield Supported Homes",
    type: "Supported Housing",
    price: "£975K Asset Value",
    location: "Plymouth, England",
    beds: 11,
    baths: 11,
    sqft: 5300,
    tag: "FRI Lease",
    image: "https://readdy.ai/api/search-image?query=supported%20housing%20Plymouth%20Devon%20England%2C%20clean%20modern%20residential%20care%20building%2C%20coastal%20town%20setting%2C%20accessible%20entrance%20with%20ramp%2C%20neat%20hedged%20front%20garden%2C%20soft%20overcast%20South%20West%20England%20daylight%2C%20professional%20property%20photography&width=600&height=400&seq=125&orientation=landscape",
  },
  {
    id: 26,
    title: "Willowmere Care Village",
    type: "Assisted Living",
    price: "£2.78M Asset Value",
    location: "Cheltenham, England",
    beds: 32,
    baths: 32,
    sqft: 15400,
    tag: "25-Year Lease",
    image: "https://readdy.ai/api/search-image?query=care%20village%20Gloucestershire%20England%2C%20premium%20large%20assisted%20living%20campus%2C%20Georgian-influenced%20facade%2C%20extensive%20manicured%20grounds%2C%20wide%20paths%2C%20elegant%20entrance%2C%20warm%20golden%20Cotswolds%20light%2C%20luxury%20residential%20care%20architecture%2C%20Cheltenham%20England&width=600&height=400&seq=126&orientation=landscape",
  },
  {
    id: 27,
    title: "Ashdown Sheltered Residence",
    type: "Sheltered Housing",
    price: "£810K Asset Value",
    location: "Ipswich, England",
    beds: 8,
    baths: 8,
    sqft: 4050,
    tag: "CPI+1% Rent",
    image: "https://readdy.ai/api/search-image?query=sheltered%20housing%20Suffolk%20England%2C%20neat%20low-rise%20residential%20care%20building%2C%20tidy%20front%20boundary%20wall%2C%20accessible%20flat%20entrance%2C%20community%20bench%20seating%20in%20garden%2C%20warm%20East%20Anglian%20afternoon%20light%2C%20professional%20architecture%20photography%2C%20Ipswich%20England&width=600&height=400&seq=127&orientation=landscape",
  },
  {
    id: 28,
    title: "Crescent View Supported Living",
    type: "Supported Housing",
    price: "£1.34M Asset Value",
    location: "Bournemouth, England",
    beds: 14,
    baths: 14,
    sqft: 6600,
    tag: "Fully Leased",
    image: "https://readdy.ai/api/search-image?query=supported%20living%20residence%20Dorset%20England%2C%20modern%20purpose-built%20care%20building%2C%20bright%20rendered%20facade%2C%20accessible%20wide%20entrance%2C%20well%20maintained%20coastal%20garden%2C%20warm%20seaside%20sunlight%2C%20professional%20property%20photography%2C%20Bournemouth%20Dorset%20England&width=600&height=400&seq=128&orientation=landscape",
  },
  {
    id: 29,
    title: "Grangehill Assisted Living",
    type: "Assisted Living",
    price: "£1.72M Asset Value",
    location: "Swansea, Wales",
    beds: 20,
    baths: 20,
    sqft: 9500,
    tag: "FRI Lease",
    image: "https://readdy.ai/api/search-image?query=assisted%20living%20facility%20South%20Wales%2C%20large%20modern%20care%20home%20building%2C%20Welsh%20hillside%20backdrop%2C%20wide%20accessible%20entrance%20courtyard%2C%20neat%20ornamental%20garden%2C%20warm%20Welsh%20afternoon%20light%2C%20professional%20real%20estate%20photography%2C%20Swansea%20Wales&width=600&height=400&seq=129&orientation=landscape",
  },
  {
    id: 30,
    title: "Birkdale Court Sheltered Housing",
    type: "Sheltered Housing",
    price: "£795K Asset Value",
    location: "Southport, England",
    beds: 9,
    baths: 9,
    sqft: 4200,
    tag: "CPI+1% Rent",
    image: "https://readdy.ai/api/search-image?query=sheltered%20housing%20scheme%20Lancashire%20England%2C%20low-rise%20residential%20care%20building%2C%20seaside%20town%20setting%2C%20communal%20seating%20garden%2C%20clean%20brick%20and%20render%20facade%2C%20accessible%20entry%2C%20coastal%20light%2C%20professional%20property%20photography%2C%20Southport%20Merseyside%20England&width=600&height=400&seq=130&orientation=landscape",
  },
  {
    id: 31,
    title: "Pinecroft Supported Housing",
    type: "Supported Housing",
    price: "£1.08M Asset Value",
    location: "Middlesbrough, England",
    beds: 12,
    baths: 12,
    sqft: 5650,
    tag: "25-Year Lease",
    image: "https://readdy.ai/api/search-image?query=supported%20housing%20Teesside%20England%2C%20modern%20residential%20care%20building%2C%20neat%20exterior%2C%20accessible%20ramp%20and%20pathway%2C%20well%20kept%20garden%2C%20warm%20North%20East%20England%20afternoon%20light%2C%20professional%20property%20photography%2C%20Middlesbrough%20Teesside%20England&width=600&height=400&seq=131&orientation=landscape",
  },
  {
    id: 32,
    title: "Riverbend Assisted Living",
    type: "Assisted Living",
    price: "£2.22M Asset Value",
    location: "Cambridge, England",
    beds: 26,
    baths: 26,
    sqft: 12300,
    tag: "Fully Leased",
    image: "https://readdy.ai/api/search-image?query=prestigious%20assisted%20living%20facility%20Cambridgeshire%2C%20elegant%20large%20care%20home%20riverside%20setting%2C%20modern%20brick%20and%20glass%20architecture%2C%20manicured%20gardens%2C%20warm%20golden%20Cambridge%20light%2C%20professional%20architectural%20photography%2C%20Cambridge%20England&width=600&height=400&seq=132&orientation=landscape",
  },
  {
    id: 33,
    title: "Ferndale Supported Homes",
    type: "Supported Housing",
    price: "£1.19M Asset Value",
    location: "Newport, Wales",
    beds: 13,
    baths: 13,
    sqft: 6100,
    tag: "FRI Lease",
    image: "https://readdy.ai/api/search-image?query=supported%20housing%20South%20Wales%2C%20clean%20modern%20residential%20care%20building%2C%20Welsh%20town%20setting%2C%20accessible%20wide%20entrance%2C%20neat%20maintained%20garden%2C%20soft%20overcast%20daylight%2C%20professional%20property%20photography%2C%20Newport%20Wales&width=600&height=400&seq=133&orientation=landscape",
  },
  {
    id: 34,
    title: "Oakdale Assisted Living",
    type: "Assisted Living",
    price: "£1.91M Asset Value",
    location: "Blackpool, England",
    beds: 22,
    baths: 22,
    sqft: 10400,
    tag: "25-Year Lease",
    image: "https://readdy.ai/api/search-image?query=assisted%20living%20facility%20Lancashire%20England%2C%20large%20purpose-built%20care%20home%2C%20coastal%20town%20backdrop%2C%20well%20maintained%20front%20garden%2C%20wide%20accessible%20entrance%2C%20warm%20seaside%20afternoon%20light%2C%20professional%20real%20estate%20photography%2C%20Blackpool%20Lancashire%20England&width=600&height=400&seq=134&orientation=landscape",
  },
  {
    id: 35,
    title: "Cedarwood Court Sheltered Housing",
    type: "Sheltered Housing",
    price: "£865K Asset Value",
    location: "Gloucester, England",
    beds: 10,
    baths: 10,
    sqft: 4700,
    tag: "CPI+1% Rent",
    image: "https://readdy.ai/api/search-image?query=sheltered%20housing%20Gloucestershire%20England%2C%20neat%20low-rise%20residential%20care%20scheme%2C%20communal%20courtyard%20garden%2C%20bench%20seating%2C%20accessible%20paths%2C%20warm%20golden%20Cotswolds%20afternoon%20light%2C%20professional%20property%20photography%2C%20Gloucester%20England&width=600&height=400&seq=135&orientation=landscape",
  },
];

export const propertyTypes = ["All", "Assisted Living", "Supported Housing", "Sheltered Housing"];
